export default __webpack_public_path__ + "static/media/cat-icon.89c26dee.svg";